// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"58":"quill","76":"common"}[chunkId] || chunkId) + ".js";
};